import type { ContactHasBBWaardecheckContactRequestEventFilter } from './types.flow';
import type { Node_NodeContainer_Leaf_Activity_Event_Contact__Input } from '~/graphql/types';

import asHasFilterInput from '../../Primitive/Has/asHasFilterInput';

const asHasBBWaardecheckContactRequestEventFilterInput = (
  filter: ContactHasBBWaardecheckContactRequestEventFilter,
): Node_NodeContainer_Leaf_Activity_Event_Contact__Input | null => ({
  App: {
    BBWaardecheck: {
      ContactRequest: {
        has: asHasFilterInput(filter.has),
      },
    },
  },
});

export default asHasBBWaardecheckContactRequestEventFilterInput;
